import { NgModule } from '@angular/core';
import { TelerikReportingModule } from '@progress/telerik-angular-report-viewer';


@NgModule({
  imports: [
    TelerikReportingModule
  ],
  exports: [
    TelerikReportingModule
  ],
  providers: [
   
  ],
  declarations: []
})
export class KendoModule { }
